export const configuration = {
    //serverUrl: process.env.REACT_APP_SERVER_URL || 'http://localhost:8080',
    serverUrl: 'https://api.the-real-insight.com',
    //mode: process.env.REACT_APP_MODE || 'test',
    mode: 'production',    
}
